
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import bgNavPage from "@/components/bg-nav-page/index.vue";
import bgNavPageItem from "@/components/bg-nav-page-item/index.vue";
import BaseInfo from "./base-info.vue";
import PaymentType from "./payment-type.vue";
import ContactInfo from "./contact-info.vue";
import DevInfo from "./dev-info/index.vue";
import ProductionInfo from "./production-info/index.vue";
import FactoryInfo from "./factory-info/index.vue";
import FactoryImages from "./factory-images.vue";
import FactoryExaminingReport from "./factory-examining-report.vue";
import AddressInfo from "./address-info.vue";
import { SupplierFormCtrl } from "@/service/supplier-meta/common/SupplierFormCtrl";
import { FormModel } from "@/service/common/entity/FormModel";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { genCacheMixin } from "../../common/cache.mixin";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { getCustomSupplierType } from "@/service/supplier-meta/common/supplier-info-service";
import { customSupplierTypeEnum } from "@/service/supplier-meta/enums/customSupplierTypeEnum";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
@Component({
  components: {
    bgNavPage,
    bgNavPageItem,
    BaseInfo,
    PaymentType,
    ContactInfo,
    DevInfo,
    ProductionInfo,
    FactoryInfo,
    FactoryImages,
    FactoryExaminingReport,
    AddressInfo,
  },
  mixins: [
    genCacheMixin({
      field: "formData",
      saveKey: "SupplierInfo",
      useCache: (ctx: SupplierInfo) =>
        !(ctx.data && typeof ctx.data === "object"),
      cacheRecovered: function (ctx, data) {
        setTimeout(() => {
          ctx.recoverFormsData(data);
        });
      },
    }),
  ],
})
export default class SupplierInfo extends SupplierFormCtrl {
  @Prop() isClothingCategory!: boolean;
  @Prop() submitData!: SupplierInfoSubmitBO;
  /** 传入数据，用于初始化渲染 */
  @Prop({ required: false }) data?: SupplierInfoSubmitBO;
  formData: FormModel = {};
  get devInfoVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return (
      this.sourceType === sourceTypeEnum.pmc_supplier ||
      (!!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_面辅料,
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType))
    );
  }
  get productionInfoVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return (
      this.sourceType === sourceTypeEnum.pmc_supplier ||
      this.sourceType === sourceTypeEnum.pmc_factory ||
      (!!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType))
    );
  }
  get factoryInfoVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return (
      !!customSupplierType &&
      [
        customSupplierTypeEnum.服装_成衣_OEM,
        customSupplierTypeEnum.服装_成衣_ODM,
        customSupplierTypeEnum.服装_成衣_IPD,
      ].includes(customSupplierType)
    );
  }
  get addressInfoVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return (
      !!customSupplierType &&
      [
        customSupplierTypeEnum["服装_成衣_FGP/VMI"],
        customSupplierTypeEnum.服装_成衣_OEM,
        customSupplierTypeEnum.服装_成衣_ODM,
        customSupplierTypeEnum["非服装_FGP/VMI"],
        customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
      ].includes(customSupplierType)
    );
  }
  // 是否隐藏产能操作栏
  get hideActionBar(): boolean {
    return this.sourceType === sourceTypeEnum.pmc_factory;
  }
  get factoryImagesVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return (
      !!customSupplierType &&
      [
        customSupplierTypeEnum.服装_成衣_OEM,
        customSupplierTypeEnum.服装_成衣_ODM,
        customSupplierTypeEnum.服装_成衣_IPD,
      ].includes(customSupplierType)
    );
  }
  get factoryExaminingReportVisible(): boolean {
    const customSupplierType = this.getCustomSupplierType();
    return customSupplierType === customSupplierTypeEnum.服装_面辅料;
  }
  @Watch("formData", {
    deep: true,
    immediate: true,
  })
  /** 内部表单校验/渲染依赖外部字段值，需要同步进来 */
  handleformDataChange(val: SupplierInfoSubmitBO) {
    this.$emit("formDataChange", this.formData);
  }
  // created() {}
  mounted() {
    if (this.data && typeof this.data === "object") {
      this.recoverFormsData(this.data);
    }
  }
  getCustomSupplierType() {
    const data = this.submitData as any as SupplierInfoSubmitBO;
    const customSupplierType = getCustomSupplierType(
      this.isClothingCategory,
      data.factoryInfo?.supplyClassification,
      data.enterpriseInfo?.supplyType
    );
    return customSupplierType;
  }
  getFormsRef() {
    return [
      this.$refs.baseInfo,
      this.$refs.paymentType,
      this.$refs.contactInfo,
      this.$refs.devInfo,
      this.$refs.productionInfo,
      this.$refs.factoryInfo,
      this.$refs.factoryImages,
      this.$refs.factoryExaminingReport,
      this.$refs.addressInfo,
    ] as SupplierForm[];
  }
  recoverFormsData(data: any) {
    const refs = this.getFormsRef();
    refs.forEach((ref) => {
      ref?.patchFormData(data);
    });
  }
}
